export default __webpack_public_path__ + "static/column-with-negative-values-b240fbaaddb44a6e6df5c32a6901bf1f.png";